<app-notification [errorMsg]="errorMsg"></app-notification>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="matterForm">
          <div class="row">
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="orgName" class="form-label">Organization Name
                  @if (getFieldInfo('orgName'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control" type="text" readonly formControlName="orgName" id="orgName">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="orgQbId" class="form-label">QuickBook Id
                  @if (getFieldInfo('orgQbId'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control" type="text" readonly formControlName="orgQbId" id="orgQbId">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label for="name" class="form-label">Matter Name
                  @if (getFieldInfo('name'); as info) {
                    @if (info.showInformation === 'Yes' && info.informationText) {
                      <info-tooltip [infoText]="info.informationText"></info-tooltip>
                    }
                  }
                </label>
                <input class="form-control" type="text" readonly formControlName="name" id="name">
              </div>
            </div>
            <div class="col-xl-4">
              <div class="mb-3">
                <label class="form-label">Status<span style="color:var(--al-danger);">*</span>
                @if (getFieldInfo('statusCode'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <select class="form-select" formControlName="statusCode">
                <option value="" selected>Select</option>
                @for (value of statusDropdown; track value) {
                  <option
                    [selected]="value==matterForm.value.statusCode" [value]="value">
                    {{value}}
                  </option>
                }
              </select>
              @if (submitted && statusCode && statusCode.invalid) {
                <span style="color:var(--al-danger)">Status is
                required</span>
              }

            </div>
          </div>
          <div class="col-xl-4">
            <div class="mb-3">
              <label for="number" class="form-label">Matter Number
                @if (getFieldInfo('number'); as info) {
                  @if (info.showInformation === 'Yes' && info.informationText) {
                    <info-tooltip [infoText]="info.informationText"></info-tooltip>
                  }
                }
              </label>
              <input class="form-control" formControlName="number" type="text" id="number" appSpellCheck>
            </div>
          </div>

          <!-- <div class="col-xl-4">
          <div class="mb-3">
            <label for="timeIncrement" class="form-label">Time Increment</label><span style="color:var(--al-danger);">*</span>
            <input class="form-control" formControlName="timeIncrement" type="number" id="timeIncrement">
            <span style="color:var(--al-danger)" *ngIf="submitted && timeIncrement && timeIncrement.invalid">Time Increment is required</span>
          </div>
        </div> -->
        <!-- <div class="col-xl-4">
        <div class="mb-3">
          <label class="form-label">Invoice Type</label><span style="color:var(--al-danger);">*</span>
          <select class="form-select" formControlName="invType">
            <option value="" selected>Select</option>
            <option *ngFor="let invType of invoiceTypes" [selected]="matterForm.statusCode === invType">{{invType}} </option>
          </select>
          <span style="color:var(--al-danger)" *ngIf="submitted && invType && invType.invalid">Invoice Type is required</span>
        </div>
      </div> -->

      <div class="col-xl-4">
        <div class="form-check mb-3" style=" padding-top: 8%; ">
          <input class="form-check-input" formControlName="isBillable" type="checkbox"
            id="formCheck1">
          <label class="form-check-label" for="formCheck1"> Billable
            @if (getFieldInfo('isBillable'); as info) {
              @if (info.showInformation === 'Yes' && info.informationText) {
                <info-tooltip [infoText]="info.informationText"></info-tooltip>
              }
            }
          </label>
        </div>
      </div>
      <!-- <div class="col-xl-8">
      <div class="mb-3">
        <label for="notes">Notes</label><span style="color:var(--al-danger);">*</span>
        <textarea id="notes" formControlName="notes" class="form-control" rows="2" [readonly]="readable"></textarea>
        <span style="color:var(--al-danger)" *ngIf="submitted && notes && notes.invalid">Notes is required</span>
      </div>
    </div> -->
  </div>

</form>
</div>
</div>
@if (!viewOnly) {
  <div class="row">
    <div class="col-xl-12">
      <div class="button-items" style="float: right;">
        <a class="btn btn-primary" (click)="saveMatter()" pTooltip="Save matter" appActionTooltip>Save@if (isLoading) {
          <i style="margin-left: 7px;"
          class="fa fa-solid fa-sync fa-spin"></i>
        } </a>
        <a class="btn btn-secondary" (click)="closeDialog()" pTooltip="Cancel" appActionTooltip> Cancel </a>
      </div>
    </div>
  </div>
}
</div>
</div>
